import { render, staticRenderFns } from "./StreamerDeviceTab.vue?vue&type=template&id=54badbfe&scoped=true&"
import script from "./StreamerDeviceTab.vue?vue&type=script&lang=js&"
export * from "./StreamerDeviceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54badbfe",
  null
  
)

export default component.exports